export const GET_FEATURE_TOGGLE_URL = featureId => `/advisor-service/feature-toggle/user/${featureId}`;
export const GET_FEATURE_TOGGLE = 'featureToggle/GET_FEATURE_TOGGLE';
export const GET_FEATURE_TOGGLE_SUCCESS = 'featureToggle/GET_FEATURE_TOGGLE_SUCCESS';
export const GET_FEATURE_TOGGLE_FAIL = 'featureToggle/GET_FEATURE_TOGGLE_FAIL';
